import { useMutation } from "react-query";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { ReferralApi, type ReferralCodeSubmissionSource } from "../../../services";

export const useUpdateReferralCode = () => {
  return useMutation(
    MUTATION_KEYS.updateReferralCode,
    ({ referralCode, uuid, source }: { referralCode: string; uuid: string; source?: ReferralCodeSubmissionSource }) => {
      return ReferralApi.init().updateReferralCode(uuid, referralCode, "", source);
    }
  );
};
